var map = {
	"./part-0.svg": "14qD",
	"./part-0_ovr.svg": "U2Ud",
	"./part-1.svg": "+3Mn",
	"./part-1_ovr.svg": "Ihds",
	"./part-2.svg": "tJuj",
	"./part-2_ovr.svg": "NAY/",
	"./part-3.svg": "j7o1",
	"./part-3_ovr.svg": "08MX",
	"./part-4.svg": "YJeN",
	"./part-4_ovr.svg": "SnsQ",
	"./part-5.svg": "fVSn",
	"./part-5_ovr.svg": "BHQJ",
	"./part-6.svg": "VpC5",
	"./part-6_ovr.svg": "yLsD",
	"./part-7.svg": "UdFo",
	"./part-7_ovr.svg": "y/zO",
	"./part-8.svg": "8smP",
	"./part-8_ovr.svg": "i8/x",
	"./part-9.svg": "MJ9L",
	"./part-9_ovr.svg": "7YFN"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "A2TI";